import { required, Validator } from '@/entities/validation';
import { Schedule } from '@/entities/analytics-schedule/model';

export const validate: Validator<Schedule> = record => [
  ...required([...record.assignees, ...record.assignedGroups], 'assignees'),
];
